var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperplanewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.156 20.956a.605.605 0 0 1-.466-.2l-9.334-9.334c-.133-.133-.2-.4-.2-.6.067-.2.2-.4.4-.466l14.667-5.334c.267-.066.533 0 .667.134.2.2.266.466.133.666L14.69 20.49c-.067.2-.267.4-.467.4 0 .067 0 .067-.067.067Zm-8.133-9.734 7.867 7.867 4.466-12.333-12.333 4.466Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.156 14.956c-.2 0-.4-.067-.533-.267-.2-.267-.2-.733.133-.933L19.09 5.089c.266-.2.733-.2.933.133.2.267.2.734-.133.934L8.556 14.822c-.133.067-.267.134-.4.134Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.157 20.289c-.4 0-.667-.267-.667-.667V14.29c0-.4.267-.667.667-.667s.667.267.667.667v5.333c0 .4-.267.667-.667.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.156 20.289c-.133 0-.267-.067-.4-.133-.267-.2-.333-.667-.067-.934l2.334-2.933c.2-.267.666-.333.933-.067.267.2.333.667.067.934l-2.4 2.933c-.067.133-.267.2-.467.2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    transform: "translate(4.156 4.956)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplanewhite);
export default __webpack_public_path__ + "static/media/paperplanewhite.9b6f6d3b33ccf1c4b58e69d6762c4d63.svg";
export { ForwardRef as ReactComponent };